import React from 'react';

interface TextInputProps {
  label: string;
  value: string;
  required?: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
}

const TextInput: React.FC<TextInputProps> = ({ label, value, required, disabled, onChange }) => (
  <div className="mb-3">
    <label className="form-label">
      {label}
      {required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
    </label>
    <input
      type="text"
      className="form-control"
      value={value}
      required={required}
      disabled={disabled}
      onChange={e => onChange(e.target.value)}
    />
  </div>
);

export default TextInput;
